module.exports = __webpack_public_path__ + "img/ctrl-c-stub-mid-1.e8fd9bf8.svg";